<template>
  <div class="detail-wrap" style="height: 100%;">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          申请单号：<span v-if="formData.applyNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.applyNo
          }}</span>
          <span v-else class="information"> 待生成</span>
          <!-- 状态 -->
          <span v-if="formData.stat == 1" class="information">制单</span>
          <span class="information" v-else-if="formData.stat == 2">驳回</span>
          <span class="information" v-else-if="formData.stat == 3">审批中</span>
          <span class="information" v-else-if="formData.stat == 5">已审批</span>
          <span class="information" v-else-if="formData.stat == 6">已提交付</span>
          <span class="information" v-else-if="formData.stat == 9">已付款</span>
          <span class="information" v-else-if="formData.stat == 99">取消</span>
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="isSite && (formData.stat == 1 || formData.stat == 2) && settleApplySave" @click="saveData(1)">保存
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="isSite && (formData.stat == 1 || formData.stat == 2) && settleApplySaveAndSubmit" @click="saveData(2)">保存并提交
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="!isSite && formData.stat == 3 && settleApplyReject" @click="rejectApply">驳回
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="!isSite && formData.stat ==3 && settleApplyCheck" @click="checkApply">审核
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="!isSite && formData.stat == 5 && settleApplycommitPay" @click="commitPayApply">提交付款
          </el-button>
        </div>
      </div>
      <div>
        <div style="display: flex;height: 125vh;">
          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box rightCs" style="width:99%">
            <div class="d-item">
              <div class="title first">
                <b>业务信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      服务中心
                    </th>
                    <td >
                      <el-input type="text" autocomplete="off" v-model="formData.orgName" :disabled="true" clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      网点编码
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.siteCode" clearable :readonly="true" :disabled="isSite">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop = true"></i>
                      </el-input>
                    </td>
                    <th>
                      网点名称
                    </th>
                    <td >
                      <el-input type="text" autocomplete="off" v-model="formData.siteName" :disabled="true" clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      结算单号
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.settleNo" clearable :readonly="true">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="selectBatchSettle"></i>
                      </el-input>
                    </td>
                  </tr>
                  <tr>

                    <th>
                      结算月份
                    </th>
                    <td >
                      <el-input type="text" autocomplete="off" v-model="formData.settleMonth" :disabled="true" clearable/>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      扣税方式
                    </th>
                    <td >
                      <el-select v-model="formData.taxType" placeholder="请选择扣税方式"  clearable>
                        <el-option :value="1" label="票前扣税"></el-option>
                        <el-option :value="2" label="票后扣税"></el-option>
                      </el-select>
                    </td>
                    <th>
                      对接单号
                    </th>
                    <td >
                      <el-input type="text" autocomplete="off" v-model="formData.sendNo" :disabled="true" clearable/>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      结算单备注
                    </th>
                    <td colspan="7">
                      <el-input class="annotate" type="textarea" :rows="2"  size="small" disabled
                                v-model="formData.settleRemark" ></el-input>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      申请单备注
                    </th>
                    <td colspan="7">
                      <el-input class="annotate" type="textarea" :rows="2" placeholder="请输入内容" size="small"
                                v-model="formData.applyRemark" clearable></el-input>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      驳回备注
                    </th>
                    <td colspan="7">
                      <el-input class="annotate" type="textarea" :rows="2" disabled size="small"
                                v-model="formData.rejectRemark" clearable></el-input>
                    </td>
                  </tr>
                  <tr>
                    <th>审核人</th>
                    <td>{{ formData.checkMan }}</td>
                    <th>审核时间</th>
                    <td>{{ formData.checkDate }}</td>
                    <th>提交付款人</th>
                    <td>{{ formData.payMan }}</td>
                    <th>提交付款时间</th>
                    <td>{{ formData.payDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                <div class="title first"><b>结算明细</b></div>
              </div>
              <div>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                           @checkbox-all="selectChangeEvent" :data="formData.sfSettleApplyLineDTOList">
                  <vxe-column field="lineType" title="类型" width="60">
                    <template #default="{ row }">
                      <span v-if="row.lineType == 1">安装费</span>
                      <span v-if="row.lineType == 2">维修费</span>
                      <span v-if="row.lineType == 9">其他费</span>
                      <span v-if="row.lineType == 0">汇总</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="yingjieZongjiner" title="应结总金额" width="80"/>
                  <vxe-column field="yijieZongjiner" title="已结总金额" width="80"/>
                  <vxe-column field="daijieZongjiner" title="待结总金额" width="80"/>
                  <vxe-column field="fapiaoZongjiner" title="发票总金额" width="80"/>
                  <vxe-column field="shifuZongjiner" title="实付总金额" width="80"/>
                  <vxe-column field="hexiaoZongjiner" title="核销总金额" width="80"/>
                </vxe-table>
              </div>
            </div>

            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                <div class="title first"><b>发票明细</b></div>
                <div class="item-button" style="margin-top: 8px;">
                  <el-button type="primary" class="button-sty btn_zdy" @click="addInvoice"
                           v-if="formData.stat== 1 || formData.stat== 2" >
                    <i class="el-icon-plus"></i>
                    新增发票
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="deleteItemData"
                             v-if="formData.stat== 1 || formData.stat== 2" >
                    <i class="el-icon-plus"></i>
                    删除发票
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="downDocumentMany()">
                    <i class="el-icon-plus"></i>
                    批量下载
                  </el-button>
                </div>
              </div>
              <div>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEventDocument"
                           @checkbox-all="selectChangeEventDocument" :data="formData.sfSettleApplyInvoiceDTOList">
                  <vxe-column type="checkbox" width="40" />
                  <vxe-column field="invoiceNo" title="发票号" width="150" />
                  <vxe-column field="invoiceType" title="费用类型" width="80">
                    <template #default="{ row }">
                      <span v-if="row.invoiceType == 1">安装费</span>
                      <span v-if="row.invoiceType == 2">维修费</span>
                      <span v-if="row.invoiceType == 3">其他费</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="invoiceNoAmount" title="发票金额" width="80"/>
                  <vxe-column field="taxRate" title="税率" width="80">
                    <template #default="{ row }">
                      <span>{{ row.taxRate }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="taxAmount" title="税金" width="80"/>
                  <vxe-column field="invoiceRemark" title="备注" width="80"/>
                  <vxe-column field="shifuZongjiner" title="发票验证" width="80">
                    <template #default="{ row }">
                      <span v-if="row.correctCheck == 0">待验证</span>
                      <span v-if="row.correctCheck == 1">已同步费控</span>
                      <span v-if="row.correctCheck == 8">验真</span>
                      <span v-if="row.correctCheck == 9">验假</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="correctCheckRemark" title="验假备注" width="80"/>
                  <vxe-column field="invoicePic" title="发票文件" width="80">
                    <template #default="{ row }">
                      <span v-if="row.invoicePic" @click="openVideo(row.invoicePic)" style="color: blue;">查看</span>
                    </template>
                  </vxe-column>
<!--                  <vxe-column field="invoicePic" title="操作" width="80">-->
<!--                    <template #default="{ row ,rowIndex}">-->
<!--                      <span @click="editInvoice(row,rowIndex)">修改</span>-->

<!--                    </template>-->
<!--                  </vxe-column>-->
                </vxe-table>
              </div>
            </div>

            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                <div class="title first"><b>付款明细</b></div>
              </div>
              <div>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                           @checkbox-all="selectChangeEvent" :data="formData.sfSettleApplyPayDTOList">
                  <vxe-column type="checkbox" width="40" />
                  <vxe-column field="payNo" title="付款单号" width="80"/>
                  <vxe-column field="invoiceNo" title="发票号" width="80"/>
                  <vxe-column field="payType" title="付款方式" width="80"/>
                  <vxe-column field="payAmount" title="付款金额" width="80"/>
                  <vxe-column field="payRemark" title="备注" width="80"/>
                </vxe-table>
              </div>
            </div>


            <div style="height:250px"></div>

          </div>
        </div>
      </div>
    </el-form>



    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList" />


    <sitePop v-if="showSitePop" :visiable.sync="showSitePop"  :multi="true" @commit="siteCommit" />

    <batchSettlePop v-if="showBatchSettle" :visiable.sync="showBatchSettle" :param="{siteId:formData.siteId}" :multi="true" @commit="batchSettleCommit" />

    <invoiceDialog v-if="showInvoice" :title="invoiceTitle" :visiable.sync="showInvoice" :param="{siteId:formData.siteId}" :invoiceIndex="invoiceIndex"
                   :multi="true" @commit="invoiceCommit" :taxData="taxData" :rowData="invoiceData"/>

          <!-- 文件预览 -->
    <Preview v-if="showPreview" @closeD="closeD33" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />
    <rejectDialog v-if="showRejectDialog"  :visiable.sync="showRejectDialog"
                   :multi="true" @commit="invoiceCommit"  :id="formData.id" @goBackIndex="goBackIndex"/>
  </div>
</template>
<script>
import checkSubjectSearch from "@/components/formItem/checkSubjectSearchPro.vue"
import Tinymce from '@/components/Tinymce';
import store from "@/store";
import api from '@/api/projectApi'
import { uploadFileFormat, echoFileFormat } from '@/util/uploadFormat'
import sitePop from "@/views/dialogCommon/radioSiteDialog.vue"
import batchSettlePop from './radioSettleDialog.vue'
import invoiceDialog from './invoiceDialog.vue'
import DictSelect from "@/components/formItem/dictSelect.vue";
import { mapGetters } from "vuex";
import PhotoUpload from "@/components/formItem/photoUpload.vue";
import { siteMixins } from "@/mixins/tabChang";
import request from "@/router/axios";
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";

import rejectDialog from './rejectDialog.vue'
import applicationRejectDialog from "@/views/finance/cost/application/rejectDialog.vue";
export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    type: String,
    settleId:[String, Number],
  },
  components: {
    applicationRejectDialog,
    Preview,
    batchSettlePop,
    invoiceDialog,
    PhotoUpload,
    DictSelect,
    checkSubjectSearch,
    sitePop,
    Tinymce,
    rejectDialog,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      selectedDataDocument:[],
      settleApplyReject:false,
      settleApplyCheck:false,
      settleApplycommitPay:false,
      settleApplySave:false,
      settleApplySaveAndSubmit:false,

      taxData:{},
      invoiceIndex:null,
      invoiceData:{},
      isSecondAnswer: null,
      invoiceTitle:'',
      snUserId: null,
      imgVisbleURL: '',
      showPreview: false,
      showRejectDialog:false,
      loading: false,
      initiateAppeal: false,
      formLabelWidth: '80px',
      justShow: false,
      isSite: null,

      dialogImageUrlList: [],
      dialogVisible: false,
      uploadFileUrl: api.uploadFileUrl,

      form2: {
        appealRemark: '',
        siteAnswerNote: '',
      },
      formData: {
        stat:1,
        sfSettleApplyLineDTOList:[],
        sfSettleApplyInvoiceDTOList:[],
      },
      picList4: [],
      picList5: [],
      picList6: [],
      showPhotoList0: [],
      showPhotoList1: [],
      operationDTOList: [],

      showPhoto: true,
      checkSubjectOption: [],
      brandOptions: [],
      showSitePop: false,
      showBatchSettle:false,
      showInvoice:false,

      upload_btn1: true,
      upload_btn2: true,
      upload_btn3: true,

      radio: '1',
      showEdit: false,

      activeName: 'first',
      dialog: {
        one: false,
      },
      fileList: [],

      isEdit: false,
      dataId: '',
    };
  },
  watch: {
    'formData.adjustAmount': {
      handler(newVal, oldVal) {
        console.log('formData.adjustAmount', newVal, oldVal)
        if (this.formData.standardAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.standardAmount': {
      handler(newVal, oldVal) {
        console.log('formData.standardAmount', newVal, oldVal)
        if (this.formData.adjustAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    // 'formData.checkSubjectId': {
    //   deep: true,
    //   handler(newVal) {
    //     this.checkSubjectSelectOne()
    //   }
    // }
  },

  computed: {
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
    api() {
      return api
    },
    ...mapGetters(["permissions"])

  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.settleId && !isNaN(this.settleId)){
      this.getSettleMsg()
    }

    const userInfo = store.getters.userInfo;
    this.settleApplyReject = this.permissions["settleApplyReject"];
    this.settleApplyCheck = this.permissions["settleApplyCheck"];
    this.settleApplycommitPay = this.permissions["settleApplycommitPay"];
    this.settleApplySave = this.permissions["settleApplySave"];
    this.settleApplySaveAndSubmit = this.permissions["settleApplySaveAndSubmit"];


    if (userInfo.snUserId) {
      this.isSite = true;
      this.snUserId = userInfo.snUserId
      console.log(this.isSite, this.snUserId)
      this.formData.siteCode = this.currentSiteData.userAccount
      this.formData.siteName = this.currentSiteData.userName
      this.formData.siteId = this.currentSiteData.id
      this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
      this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
      this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
      this.taxData = {siteInvoiceRate:this.currentSiteData.snSiteInfoDTO.siteInvoiceRate,siteWxInvoiceRate:this.currentSiteData.snSiteInfoDTO.siteWxInvoiceRate,siteOtherInvoiceRate:this.currentSiteData.snSiteInfoDTO.siteOtherInvoiceRate}

    }
    console.log("this.currentSiteData--------",this.currentSiteData)
  },

  mounted() {
    this.getData()

  },

  methods: {
    deleteItemData() {
      let selectedData = this.selectedDataDocument
      if (selectedData == null || selectedData.length == 0) {
        this.$message.warning('请先选中数据')
      } else {
        let sfSettleApplyInvoiceDTOList = this.formData.sfSettleApplyInvoiceDTOList;
        selectedData.forEach(item => {
          sfSettleApplyInvoiceDTOList = sfSettleApplyInvoiceDTOList.filter(item1 => item1.invoiceNo != item.invoiceNo)
        })
        this.formData.sfSettleApplyInvoiceDTOList = sfSettleApplyInvoiceDTOList
      }
    },
    downDocumentMany(){
      let urlList = [];
      const checkIds = this.selectedDataDocument;

      if(!checkIds||checkIds.length==0){
        this.$message.error("请先选中需要下载的发票明细")
        return false;
      }

      for (let i = 0; i < checkIds.length; i++) {
        urlList.push(checkIds[i].invoicePic)
      }

      // 逐个下载URL到本地
      const downloadAll = async () => {
        for (let i = 0; i < urlList.length; i++) {
          const url = urlList[i];
          try {
            const response = await fetch(url);
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `document_${i + 1}`; // 可根据需要调整文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
          } catch (error) {
            console.error(`下载失败 ${url}:`, error);
          }
        }
      };

      downloadAll();
    },
    checkApply(){
      this.$baseConfirm('您确定要审核吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: api.sfSettleApply.checkApplyUrl,
            method: 'post',
            data: {id:this.formData.id}
          }).then(res => {
            this.$mask.close()
            if(res.data.type == "success"){
              this.$message.success('操作成功')
              this.flushed()
            }else{
              this.$message.error(res.data.message)
            }
          }).catch(e => {
            this.$mask.close()
          })
      })
    },
    commitPayApply(){
      this.$baseConfirm('您确定要提交付款吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.sfSettleApply.commitPayApplyUrl,
          method: 'post',
          data: {id:this.formData.id}
        }).then(res => {
          this.$mask.close()
          if(res.data.type == "success"){
            this.$message.success('操作成功')
            this.flushed()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    rejectApply(){
      this.showRejectDialog = true
    },
    goBackIndex(){
      this.showRejectDialog = false;
      this.getData();
    },
    getSettleMsg(){
      this.$http({
        url: api.sfSettleApply.getSettleMsgUrl,
        method: 'post',
        data: {
          id: this.settleId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        var row = response.data.data
        this.formData.settleId = row.id
        this.formData.settleNo = row.settleNo
        this.formData.settleMonth = row.orderDates
        this.formData.settleRemark = row.settleRemark
        let siteAzAmount = row.siteAzAmount ? parseFloat(row.siteAzAmount).toFixed(2) : parseFloat('0.00').toFixed(2);
        let adjustAmount = row.adjustAmount ? parseFloat(row.adjustAmount).toFixed(2) : parseFloat('0.00').toFixed(2);
        let siteWxAmount = row.siteWxAmount ? parseFloat(row.siteWxAmount).toFixed(2) : parseFloat('0.00').toFixed(2);
        let siteOtherAmount = row.siteOtherAmount ? parseFloat(row.siteOtherAmount).toFixed(2) : parseFloat('0.00').toFixed(2);
        this.formData.sfSettleApplyLineDTOList = []
        this.formData.sfSettleApplyLineDTOList.push({lineType:1,yingjieZongjiner:(Number(siteAzAmount) + Number(adjustAmount)).toFixed(2),yijieZongjiner:0,daijieZongjiner:0,
          fapiaoZongjiner:0,shifuZongjiner:0,hexiaoZongjiner:0
        })
        this.formData.sfSettleApplyLineDTOList.push({lineType:2,yingjieZongjiner:parseFloat(siteWxAmount).toFixed(2),yijieZongjiner:0,daijieZongjiner:0,
          fapiaoZongjiner:0,shifuZongjiner:0,hexiaoZongjiner:0
        })
        this.formData.sfSettleApplyLineDTOList.push({lineType:9,yingjieZongjiner:parseFloat(siteOtherAmount).toFixed(2),yijieZongjiner:0,daijieZongjiner:0,
          fapiaoZongjiner:0,shifuZongjiner:0,hexiaoZongjiner:0
        })
        this.formData.sfSettleApplyLineDTOList.push({lineType:0,yingjieZongjiner:(Number(siteAzAmount)+Number(siteWxAmount)+Number(siteOtherAmount)+Number(adjustAmount)).toFixed(2),yijieZongjiner:0,daijieZongjiner:0,
          fapiaoZongjiner:0,shifuZongjiner:0,hexiaoZongjiner:0
        })
      })
    },
    addInvoice(){
      if (!this.formData.siteId){
        this.$message.warning('请先选择对应的网点')
        return
      }
      if (this.formData.applyNo){
        this.invoiceTitle = '['+this.formData.applyNo+']上传发票新增'
      }else{
        this.invoiceTitle = '新增付款申请单上传发票'
      }
      this.invoiceIndex = -1
      this.invoiceData = null
      this.showInvoice = true;

    },
    invoiceCommit(row){
      console.log("invoiceCommit------------",row)
      if (row.index<0){
        if(row.data.invoicePic&&row.data.invoicePic.length>0){
          row.data.invoicePic = row.data.invoicePic[0].url
        }
        this.formData.sfSettleApplyInvoiceDTOList.push(row.data)
      }else{
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"id",row.data.id)
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"invoiceType",row.data.invoiceType)
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"correctCheck",row.data.correctCheck)
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"correctCheckRemark",row.data.correctCheckRemark)
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"invoiceNo",row.data.invoiceNo)
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"invoiceNoAmount",row.data.invoiceNoAmount)
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"taxRate",row.data.taxRate)
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"taxAmount",row.data.taxAmount)
        this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index],"invoiceRemark",row.data.invoiceRemark)
        if(row.data.invoicePic&&row.data.invoicePic.length>0) {
          this.$set(this.formData.sfSettleApplyInvoiceDTOList[row.index], "invoicePic", row.data.invoicePic[0].url)
        }
        // this.formData.sfSettleApplyInvoiceDTOList[row.index]= row.data
      }
    },
    editInvoice(row,index){
      if (this.formData.applyNo){
        this.invoiceTitle = '['+this.formData.applyNo+']上传发票修改'
      }else{
        this.invoiceTitle = '新增付款申请单上传发票修改'
      }
      this.invoiceIndex = index
      this.invoiceData = row
      this.showInvoice = true;
    },
    selectBatchSettle(){
      if (!this.formData.siteId){
        this.$message.warning('请先选择对应的网点')
        return
      }
      this.showBatchSettle = true
    },
    batchSettleCommit(row){
      this.formData.settleId = row.id
      this.formData.settleNo = row.settleNo
      this.formData.settleMonth = row.settleMonth
      this.formData.settleRemark = row.settleRemark
      this.formData.sfSettleApplyLineDTOList = []
      let siteAzAmount = row.siteAzAmount ? parseFloat(row.siteAzAmount).toFixed(2) : parseFloat('0.00').toFixed(2);
      let adjustAmount = row.adjustAmount ? parseFloat(row.adjustAmount).toFixed(2) : parseFloat('0.00').toFixed(2);
      let siteWxAmount = row.siteWxAmount ? parseFloat(row.siteWxAmount).toFixed(2) : parseFloat('0.00').toFixed(2);
      let siteOtherAmount = row.siteOtherAmount ? parseFloat(row.siteOtherAmount).toFixed(2) : parseFloat('0.00').toFixed(2);

      this.formData.sfSettleApplyLineDTOList.push({lineType:1,yingjieZongjiner:(Number(siteAzAmount) + Number(adjustAmount)).toFixed(2),yijieZongjiner:0,daijieZongjiner:0,
        fapiaoZongjiner:0,shifuZongjiner:0,hexiaoZongjiner:0
      })
      this.formData.sfSettleApplyLineDTOList.push({lineType:2,yingjieZongjiner:siteWxAmount,yijieZongjiner:0,daijieZongjiner:0,
        fapiaoZongjiner:0,shifuZongjiner:0,hexiaoZongjiner:0
      })
      this.formData.sfSettleApplyLineDTOList.push({lineType:9,yingjieZongjiner:siteOtherAmount,yijieZongjiner:0,daijieZongjiner:0,
        fapiaoZongjiner:0,shifuZongjiner:0,hexiaoZongjiner:0
      })
      this.formData.sfSettleApplyLineDTOList.push({lineType:0,yingjieZongjiner:(Number(siteAzAmount)+Number(siteWxAmount)+Number(siteOtherAmount)+Number(adjustAmount)).toFixed(2),yijieZongjiner:0,daijieZongjiner:0,
        fapiaoZongjiner:0,shifuZongjiner:0,hexiaoZongjiner:0
      })
    },









    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    closeD33() {
      this.showPreview = false

    },
    //     // 文件下载
        handleDownload(Vname,Vurl) {
      console.log(Vname,Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },



    downDocument(name, url) {
      console.log(name, url, "打开");
      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()

    },
    Previewf(file) {
      console.log(file);
      file.response.data.fileName = file.name
      window.open(this.picList1.url, "_blank");
      // window.open(file.response)

    },
    editViewDataUpdate() {
    this.getData();

    },

    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },

    selectChangeEventDocument(data){
      console.log('选中数据', data)
      this.selectedDataDocument = data.records
    },

    handleSuccess2(res, file, fileList) {
      this.fileList.push(res.data.url)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showConfirmDialog = false
      this.showCloseDialog = false
      this.showAuditDialog = false
      this.showCompanyComfirmDialog = false
      this.showParentCheckDialogDialog = false
      // this.reload()
      this.getData();


    },

    closeImgViewer() {
      this.dialogVisible = false
    },

    handlePictureCardPreview(file) {
      console.log(file);
      // file.response.data.fileName=file.name
      window.open(this.picList1.url, "_blank");
      // this.dialogImageUrlList = [file.url]
      // this.dialogVisible = true
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },







    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.sfSettleApply.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data;
          this.formData = data


        })
      }
    },
    saveData(type) {
      if(this.formData.siteId == null){
        this.$message.warning('请选择网点!')
        return;
      }

      if (this.formData.settleNo == null){
        this.$message.warning('请选择对应的结算单')
        return
      }
      if (this.formData.taxType == null){
        this.$message.warning('请选择对应的扣税方式')
        return
      }
      this.formData.saveType = type
      // 获取行列表和发票列表
      const lineList = this.formData.sfSettleApplyLineDTOList || [];
      const invoiceList = this.formData.sfSettleApplyInvoiceDTOList || [];
      if(this.formData.taxType==1){
        // 查找lineType=0的那条数据
        const targetLine = lineList.find(item => item.lineType === 0);
        if (!targetLine) {
        }else {
          // 获取应收总金额
          const yingjieZongjiner = parseFloat(targetLine.yingjieZongjiner) || 0;

          // 计算发票金额总和
          let invoiceTotal = 0;
          if (invoiceList && invoiceList.length > 0) {
            invoiceTotal = invoiceList.reduce((sum, invoice) => {
              const amount = (Number(invoice.invoiceNoAmount)+Number(invoice.taxAmount)) || 0;
              return sum + amount;
            }, 0);
          }
          console.log("invoiceTotal"+invoiceTotal)


          // 保留两位小数进行比较（避免浮点数精度问题）
          const yingjieZongjinerFixed = parseFloat(yingjieZongjiner.toFixed(2));
          const invoiceTotalFixed = parseFloat(invoiceTotal.toFixed(2));

          // 比较是否相等
          if (yingjieZongjinerFixed !== invoiceTotalFixed) {
            this.$message.warning('发票金额与汇总金额不一致,请检查发票')
            return
          }
        }
      }else if(this.formData.taxType==2){
        // 查找lineType=0的那条数据
        const targetLine = lineList.find(item => item.lineType === 0);
        if (!targetLine) {
        }else {
          // 获取应收总金额
          const yingjieZongjiner = parseFloat(targetLine.yingjieZongjiner) || 0;

          // 计算发票金额总和
          let invoiceTotal = 0;
          if (invoiceList && invoiceList.length > 0) {
            invoiceTotal = invoiceList.reduce((sum, invoice) => {
              const amount = parseFloat(invoice.invoiceNoAmount) || 0;
              return sum + amount;
            }, 0);
          }

          // 保留两位小数进行比较（避免浮点数精度问题）
          const yingjieZongjinerFixed = parseFloat(yingjieZongjiner.toFixed(2));
          const invoiceTotalFixed = parseFloat(invoiceTotal.toFixed(2));

          // 比较是否相等
          if (yingjieZongjinerFixed !== invoiceTotalFixed) {
            this.$message.warning('发票金额与汇总金额不一致,请检查发票')
            return
          }
        }
      }


      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()
            request({
              url: api.sfSettleApply.saveDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success('保存成功')
              this.reload()
              this.$mask.close()

              // this.$emit('editViewDataUpdate')
              // this.$baseReload()
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
          });
        }
      });
    },

    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      clearTimeout(this.timer);
    },




    parentSiteCheck() {


    },




    // 网点弹窗选中
    siteCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.siteId = row.id
      this.formData.siteName = row.name
      this.formData.siteCode = row.userAccount

      this.$http({
        url: api.snUser.getMainDataUrl,
        method: 'post',
        data: { id: row.id },
      }).then(res => {
        console.log('网点详情', res)
        this.formData.orgId = res.data.data.snSiteInfoDTO.orgId
        this.formData.orgName = res.data.data.snSiteInfoDTO.orgName
        this.formData.orgIdPath = res.data.data.snSiteInfoDTO.orgIdPath
        if (res.data.data.snSiteInfoDTO.parentSiteId) {
          this.formData.bigSiteName = res.data.data.snSiteInfoDTO.parentSiteName
          this.formData.bigSiteId = res.data.data.snSiteInfoDTO.parentSiteId
        } else {
          this.formData.bigSiteName = row.name
          this.formData.bigSiteId = row.id
        }
        this.taxData = {siteInvoiceRate:res.data.data.snSiteInfoDTO.siteInvoiceRate,siteWxInvoiceRate:res.data.data.snSiteInfoDTO.siteWxInvoiceRate,siteOtherInvoiceRate:res.data.data.snSiteInfoDTO.siteOtherInvoiceRate}
      })
    },

    handleRemove1() {
      this.picList1 = []
    },
    handleSuccess1(res, file, fileList) {
      // this.upload_btn1 = false
      // console.log(res.data.url, "url")
      // this.picList1 = [
      //   {url: res.data.url}
      // ]
      this.picList1.url = res.data.url
      this.picList1.name = file.name
      // name:file.name
      // })
      console.log(this.picList, "this.picListdezhi");
    },

    handleRemove2() {
      this.picList2 = []
    },
    // handleSuccess2(res, file, fileList) {
    //   this.upload_btn2 = false
    //   console.log(res.data.url, "url")
    //   this.picList2 = [
    //     {url: res.data.url}
    //   ]
    // },

    handleRemove3() {
      this.picList3 = []
    },
    handleSuccess3(res, file, fileList) {
      this.upload_btn3 = false
      console.log(res.data.url, "url")
      this.picList3 = [
        { url: res.data.url }
      ]
    },

    handleRemove4() {
      this.picList4 = []
    },
    handleSuccess4(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList4 = [
        { url: res.data.url }
      ]
    },

    handleRemove5() {
      this.picList5 = []
    },
    handleSuccess5(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList5 = [
        { url: res.data.url }
      ]
    },

    handleRemove6() {
      this.picList6 = []
    },
    handleSuccess6(res, file, fileList) {
      console.log(res.data.url, "url")
      this.picList6 = [
        { url: res.data.url }
      ]
    },
  },
};

</script>
<style lang="scss" scoped>
.rightCs {
  height: 100%;
  margin: 0 !important;
  padding: 0 !important;
}

// 输入框的宽度

#containt .table-detail tbody tr td {
  width: 9.5vw !important;
}

#containt .table-detail tbody tr th {
  // white-space: nowrap;
  width: 6vw !important;
}


::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  // border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 72.5vh;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  // background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}


#containt .detail-wrap .d-cont {
  // overflow: unset !important;
  margin: 0 !important;
  padding: 0 !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

::v-deep .el-image {
  width: 60px;
  height: 60px;
}

.FileName {
  display: inline-block;
  width: 165px;
  height: 40px;

  border-radius: 2px;
  color: #606266;
  border-color: rgb(232, 232, 232);
  margin-top: 0px;

  background-color: rgb(233, 233, 233);
  padding: 0px !important;
}
</style>
